export const SET_CURRENT_POST = 'SET_CURRENT_POST';

export function setCurrentPost(data) {
  return {
    type: SET_CURRENT_POST,
    data
  };
}
